import React, { useEffect, useState } from "react";
import { getUserById } from "./api/list";
import { Navigate } from "react-router-dom";
import { ChildProps } from "./utils/types/interFace";
import UnAuthorized from "./pages/unauthorized";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredAccess?: string | null;
  asCheckOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredAccess,
  asCheckOnly = false,
}) => {
  const accessToken = localStorage.getItem("accessToken");
  const [, setAccess] = useState([]);
  // Parse loggedUser from localStorage
  const definedAccess = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined ;
  const parsedAccess = definedAccess
    ? JSON.parse(definedAccess)
    : { access: [] };
  const { access }: any = parsedAccess;

  useEffect(() => {
    const definedAccess: any = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined;
    const parsedAccess = definedAccess
      ? JSON.parse(definedAccess)
      : { access: [] };
    if (definedAccess && parsedAccess) {
      getUserById(parsedAccess?.id).then((res: any) => {
        if (res?.success) {
          localStorage.setItem("loggedUser", JSON.stringify(res?.result?.user));
          setAccess(res?.result?.user);
          window.dispatchEvent(new CustomEvent("loggedUserUpdated"));
        }
      });
    }
  }, []);

  // Check if user has the required access
  const filteredAccess: any =
    access?.length > 0
      ? access?.filter(
          (item: any) =>
            item.module_name?.toLowerCase() ===
            requiredAccess?.toLocaleLowerCase()
        )
      : [];
  const hasAccess = filteredAccess?.[0]?.read_access || false;

  // Redirect if access is not allowed
  if (requiredAccess && (!filteredAccess.length || !hasAccess)) {
    return asCheckOnly ? null : <UnAuthorized/>;
  }

  // Redirect if user is not authenticated
  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }

  // Render the protected component with filteredAccess passed to children
  return (
    <>
      {React.Children.map(children, (child) => {
        // Only pass filteredAccess to valid React elements (components)
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            filteredAccess,
          } as ChildProps); // Explicitly cast to the ChildProps type
        }
        return child;
      })}
    </>
  );
};

export default ProtectedRoute;
